import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  id: "i-816815506__Layer_1",
  x: "0",
  y: "0",
  preserveAspectRatio: "none",
  style: {"enable-background":"new 0 0 1144.6 572.8"},
  version: "1.1",
  viewBox: "0 0 1144.6 572.8"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m0 572.8 380.9-323.6M0 572.8l380.9-323.6M0 0l572.3 374.4M0 0l572.3 374.4M572.3 374.4 1144.6 0M763.7 249.2l380.9 323.6",
  class: "i-816815506__st0",
  "vector-effect": "non-scaling-stroke"
}, null, -1)

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
      default: _withCtx(() => [
        _createTextVNode(".i-816815506__st0{fill:none}")
      ]),
      _: 1
    })),
    _hoisted_2
  ]))
}
export default { render: render }